<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cabinet Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (modelSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Model:</label>
              <select class="halfWidthInputField" #modelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(modelSelection.Name)"
                (change)="modelChanged(modelSelection, modelInput.value)"
                [value]="modelSelection.Value.toString()">
                @for (allowable of modelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="modelSelection.Value && modelSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sizeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Size:</label>
              <select class="halfWidthInputField" #sizeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(sizeSelection.Name)"
                (change)="selectionChanged(sizeSelection, sizeInput.value)"
                [value]="sizeSelection.Value.toString()">
                @for (allowable of sizeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="sizeSelection.Value && sizeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (cabinetHeightSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Cabinet Height:</label>
              <select class="halfWidthInputField" #cabinetHeightInput
                [class.invalidConfigurationSelection]="isInvalidSelection(cabinetHeightSelection.Name)"
                (change)="selectionChanged(cabinetHeightSelection, cabinetHeightInput.value)"
                [value]="cabinetHeightSelection.Value.toString()">
                @for (allowable of cabinetHeightSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="cabinetHeightSelection.Value && cabinetHeightSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (riserLocationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Riser Location:</label>
              <select class="halfWidthInputField" #riserLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserLocationSelection.Name)"
                (change)="selectionChanged(riserLocationSelection, riserLocationInput.value)"
                [value]="riserLocationSelection.Value.toString()">
                @for (allowable of riserLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserLocationSelection.Value && riserLocationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (unitVoltageSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Voltage:</label>
              <select class="halfWidthInputField" #unitVoltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
                (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
                [value]="unitVoltageSelection.Value.toString()">
                @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (dischargeAirLocationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Discharge Air Location:</label>
              <select class="halfWidthInputField" #dischargeAirLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(dischargeAirLocationSelection.Name)"
                (change)="selectionChanged(dischargeAirLocationSelection, dischargeAirLocationInput.value)"
                [value]="dischargeAirLocationSelection.Value.toString()">
                @for (allowable of dischargeAirLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="dischargeAirLocationSelection.Value && dischargeAirLocationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (straightDischargeAirSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Straight Discharge Air:</label>
              <select class="halfWidthInputField" #straightDischargeAirInput
                [class.invalidConfigurationSelection]="isInvalidSelection(straightDischargeAirSelection.Name)"
                (change)="selectionChanged(straightDischargeAirSelection, straightDischargeAirInput.value)"
                [value]="straightDischargeAirSelection.Value.toString()">
                @for (allowable of straightDischargeAirSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="straightDischargeAirSelection.Value && straightDischargeAirSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (riserStyleSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Riser Style:</label>
              <select class="halfWidthInputField" #riserStyleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserStyleSelection.Name)"
                (change)="selectionChanged(riserStyleSelection, riserStyleInput.value)"
                [value]="riserStyleSelection.Value.toString()">
                @for (allowable of riserStyleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserStyleSelection.Value && riserStyleSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (optionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Options:</label>
              <select class="halfWidthInputField" #optionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(optionsSelection.Name)"
                (change)="selectionChanged(optionsSelection, optionsInput.value)"
                [value]="optionsSelection.Value.toString()">
                @for (allowable of optionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="optionsSelection.Value && optionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (knockOutSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Knock Out Options:</label>
              <select class="halfWidthInputField" #knockOutInput
                [class.invalidConfigurationSelection]="isInvalidSelection(knockOutSelection.Name)"
                (change)="selectionChanged(knockOutSelection, knockOutInput.value)"
                [value]="knockOutSelection.Value.toString()">
                @for (allowable of knockOutSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="knockOutSelection.Value && knockOutSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
      @if (isHandArrangementImageAvailable()) {
        <div class="arrangementImage">
          <img class="detailImage" [src]="handArrangementImagePath()" alt="ArrangementImage" width="290" height="260"/>
        </div>
      }
    </div>
  }
</div>
